import React from "react";
import { Routes, Route } from "react-router-dom";
import LuxuryHome from "../home/Home";
import Event from "../in_company/event/Event";
import AboutUs from "../in_company/aboutUs/AboutUs";
import Latest_news from "../in_company/latest_news/Latest_news";
import Legal_notice from "../in_company/legal_notice/Legal_notice";
import Privacy_policy from "../in_company/privacy_policy/Privacy_policy";
import Latest_updates_detials from "../in_company/latest_news/latest_updates_detials/Latest_updates_detials";

import Product_Details from "../product_details/Product_Details";
import Responsibility from "../in_company/responsibility/Responsibility";
import Help from "../support/help/Help";
import Delivaries from "../support/delivaries/Delivaries";
import Terms_and_condition from "../support/terms_and_condition/Terms_and_condition";
import Personal_care from "../support/personal_care/Personal_care";
import Suggestions from "../support/suggestions/Suggestions";
import Unsubcribe from "../unsubcribe/Unsubcribe";
import Faq from "../support/faq/Faq";
import Gifts_Category from "../offerings/gifts_category/Gifts_Category";
import Gift_By_Occassion from "../offerings/gift_by_occassion/Gift_By_Occassion";
import Contact_us from "../support/contact_us/Contact_us";
import Gift_Customisation from "../offerings/gift_customisation/Gift_Customisation";
import Cart from "../cart/Cart";
import Account from "../account/Account";
import My_rewards from "../account/my_rewards/My_rewards";
import All_Orders from "../all_Orders/All_Orders";
import Communication_preferences from "../account/communication_preferences/Communication_preferences";
import Manage_address from "../account/manage_address/Manage_address";
import Manage_address_form from "../account/manage_address/manage_address_form/Manage_address_form";
import Update_email_address from "../account/update_email_address/Update_email_address";
import Update_contact_number from "../account/update_contact_number/Update_contact_number";
import Update_password from "../account/update_password/Update_password";
import Blogs from "../blogs/Blogs";
import Bespock_gift from "../bespock_gift/Bespock_gift";
import Autograph_collection from "../autograph_collection/Autograph_collection";
import Cancle_return_flow from "../cancle_return_flow/Cancle_return_flow";
import Ordered_Product_details from "../cancle_return_flow/ordered_Product_details/Ordered_Product_details";
import Blog_details from "../blogs/blog_details/Blog_details";
import Testimonials from "../testimonials/Testimonials";
import Wishlist from "../wishlist/Wishlist";
import Customisation_Product from "../Customisation_Product/Customisation_Product";
import All_Product from "../offerings/all_product/All_Product";
import Payment_Success_Modal from "../common_components/Payment_Success_Modal/Payment_Success_Modal";
import Payment_Failed_Modal from "../common_components/Payment_Failed_Modal/Payment_Failed_Modal";
import OrderDetails from "../OrderDetails/OrderDetails";
import Manage_address_form_edit from "../account/manage_address/manage_address_form/Manage_address_form_edit";

const LuxuryRoutes = () => {
  return (
    <Routes>
      <Route path="/home" element={<LuxuryHome />} />

      {/* in company start*/}
      <Route path="/events" element={<Event />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/latest-news" element={<Latest_news />} />
      <Route
        path="/latest-news-details/:id"
        element={<Latest_updates_detials />}
      />
      <Route path="/legal-notice" element={<Legal_notice />} />
      <Route path="/privacy-policy" element={<Privacy_policy />} />
      <Route path="/responsibility" element={<Responsibility />} />
      <Route path="/order-details/:id" element={<OrderDetails/>} />
      {/* in company end*/}

      {/* OFFERINGS start */}
      <Route path="/products" element={<Gifts_Category />} />
      <Route path="/all-products" element={<All_Product />} />

      <Route path="/gift-by-occasions" element={<Gift_By_Occassion />} />
      <Route path="/product-details/:id" element={<Product_Details />} />
      <Route path="/gift-customisation" element={<Gift_Customisation />} />
      <Route
        path="/product-customisation/:id"
        element={<Customisation_Product />}
      />
      {/* OFFERINGS end */}

      {/* in support start*/}
      <Route path="/help" element={<Help />} />
      <Route path="/deliveries" element={<Delivaries />} />
      <Route path="/terms-conditions" element={<Terms_and_condition />} />
      <Route path="/product-care" element={<Personal_care />} />
      <Route path="/suggestions" element={<Suggestions />} />
      <Route path="/unsubscribe" element={<Unsubcribe />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/contact-us" element={<Contact_us />} />
      {/* in support end*/}

      {/* cart route start*/}
      <Route path="/cart" element={<Cart />} />
      {/* cart route end*/}

      {/* wishlist route start*/}
      <Route path="/wishlist" element={<Wishlist />} />
      {/* wishlist route end*/}

      {/* account route start*/}
      <Route path="/account" element={<Account />} />
      <Route path="/my-rewards" element={<My_rewards />} />
      {/* account route end*/}

      {/* account Routes Start */}
      <Route path="/all-orders" element={<All_Orders />} />
      <Route
        path="/communication-preferences"
        element={<Communication_preferences />}
      />
      <Route path="/manage-address" element={<Manage_address />} />
      <Route path="/add-address" element={<Manage_address_form />} />
      <Route path="/edit-address/:id" element={<Manage_address_form_edit />} />
      <Route path="/update-email-address" element={<Update_email_address />} />
      <Route
        path="/update-contact-number"
        element={<Update_contact_number />}
      />
      <Route path="/update-password" element={<Update_password />} />
      {/* account Routes end */}

      {/* account Routes Start */}
      <Route path="/articles" element={<Blogs />} />
      <Route path="/articles-details/:id" element={<Blog_details />} />
      <Route path="/bespock-gift" element={<Bespock_gift />} />
      {/* account Routes end */}

      {/* Autograph_collection route start */}
      <Route
        path="/dgp-autograph-collection"
        element={<Autograph_collection />}
      />
      {/* Autograph_collection route end */}

      <Route path="/cancle-return" element={<Cancle_return_flow />} />
      <Route
        path="/ordered-product-details"
        element={<Ordered_Product_details />}
      />
      <Route path="/testimonials" element={<Testimonials />} />

      <Route path="/payment-success" element={<Payment_Success_Modal />} />
      <Route path="/payment-fail" element={<Payment_Failed_Modal />} />
    </Routes>
  );
};

export default LuxuryRoutes;
